define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/SelectController",
	"csi/types",
	"csi/xml",
	"csi/heading/StringSelection"
], function(declare,heading,SelectController,types,xml) {

	return declare(SelectController, {
		start: function() {
			// summary: reset renderer for controller
			this.ren = heading.getRenderer(xml.ATTR_STRING, types.FORMAT_SELECTION);
			this.inherited(arguments);
		}
	});
});